@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

.materialBulkControls {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-l;
	background-color: Colors.$col-orange;

	.action {
		margin-right: Constants.$val-spacing-xxxl;
		color: Colors.$col-white;
		font-weight: bold;
	}
}
